<div class="toast" [ngClass]="[type]" [@fadeAnimation]="{value: animationState, params: { fadeIn: toastConfig.animation.fadeIn, fadeOut: toastConfig.animation.fadeOut }}" (@fadeAnimation.done)="onFadeFinished($event)">
  <div class="title-container">
    <mat-icon class="material-symbols-outlined type-icon" [ngClass]="{ flat: isIconFlat }">{{icon}}</mat-icon>
    <h3>{{data.title}}</h3>
      <mat-icon *ngIf="!(isMobile | async).matches" class="close-button" (click)="close()" aria-label="Fechar" >close</mat-icon>
  </div>
  <p class="complement">
    {{data.text}}
  </p>
  <mat-icon *ngIf="(isMobile | async).matches" class="close-button" (click)="close()" aria-label="Fechar" >close</mat-icon>
</div>